import { format } from 'date-fns';
import { isDateOnlyString, parseDateOnlyLocal } from '@erp/shared-utils';

/** Formats a SPA date-only or timestamp string as MM/dd/yyyy, or '-' when absent/invalid. */
export function formatSpaDate(value: string | null): string {
  if (!value) return '-';
  const date = isDateOnlyString(value)
    ? parseDateOnlyLocal(value)
    : new Date(value);
  if (!date || isNaN(date.getTime())) return '-';
  return format(date, 'MM/dd/yyyy');
}
